if (!customElements.get("m-ingredient-slider")) {
  class MIngredientSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        sliderContainer: ".m-featured-slider__products",
        slideImages: ["m-featured-slider__img"],
        slideImagesContainer: ".m-featured-slider__images",
        sliderControls: ".m-slider-controls",
        prevBtn: ".m-slider-controls__button-prev",
        nextBtn: ".m-slider-controls__button-next",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const showNavigation = this.dataset.showNavigation === "true";
      const showPagination = this.dataset.showPagination === "true";
      const autoplay = this.dataset.autoplay === "true";
      const timeout = this.dataset.timeout;
      const gap = parseInt(this.dataset.slideGap) || 20;

      // Get slides per view settings
      const slidesPerViewDesktop = parseInt(this.dataset.slidesPerViewDesktop) || 3;
      const slidesPerViewTablet = parseInt(this.dataset.slidesPerViewTablet) || 2;
      const slidesPerViewMobile = parseInt(this.dataset.slidesPerViewMobile) || 1;

      const totalSlides = this.domNodes.sliderContainer.querySelectorAll('.swiper-slide').length;

      // Determine current screen size and appropriate slidesPerView
      const screenWidth = window.innerWidth;
      let currentSlidesPerView;
      if (screenWidth >= 1024) {
        currentSlidesPerView = slidesPerViewDesktop;
      } else if (screenWidth >= 768) {
        currentSlidesPerView = slidesPerViewTablet;
      } else {
        currentSlidesPerView = slidesPerViewMobile;
      }

      // Enable loop only if total slides is greater than current slidesPerView
      const enableLoop = totalSlides > currentSlidesPerView;

      this.slider = new MinimogLibs.Swiper(this.domNodes.sliderContainer, {
        speed: 400,
        loop: enableLoop,
        allowTouchMove: enableLoop,
        spaceBetween: gap,
        // autoHeight: true,
        slidesPerView: slidesPerViewMobile,
        watchOverflow: false,
        loopedSlides: enableLoop ? totalSlides : undefined,
        loopAddBlankSlides: enableLoop,
        breakpoints: {
          768: {
            slidesPerView: slidesPerViewTablet,
          },
          1024: {
            slidesPerView: slidesPerViewDesktop,
          }
        },
        autoplay: autoplay
          ? {
              delay: parseInt(timeout),
              disableOnInteraction: false,
            }
          : false,
        pagination: showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              type: "bullets",
              clickable: true,
            }
          : false,
        navigation: showNavigation
          ? {
              prevEl: this.domNodes.prevBtn,
              nextEl: this.domNodes.nextBtn,
            }
          : false,
        on: {
          init: () => {
            // Update navigation button states
            this.updateNavigationState();
          },
          slideChange: () => {
            this.updateNavigationState();
          }
        },
      });

      // Only sync image slider if it exists
      if (this.domNodes.slideImagesContainer) {
        this.imageSlider = new MinimogLibs.Swiper(this.domNodes.slideImagesContainer, {
          speed: 500,
          loop: false,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
        });

        this.slider.on("activeIndexChange", (swiper) => {
          const { realIndex, activeIndex } = swiper;
          this.imageSlider.slideTo(activeIndex);
        });

        this.imageSlider.on("activeIndexChange", (swiper) => {
          const { realIndex, activeIndex } = swiper;
          this.slider.slideTo(activeIndex);
        });
      }

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    updateNavigationState() {
      if (!this.slider || !this.domNodes.prevBtn || !this.domNodes.nextBtn) return;

      // Update prev button state
      if (this.slider.isBeginning) {
        this.domNodes.prevBtn.setAttribute('disabled', '');
      } else {
        this.domNodes.prevBtn.removeAttribute('disabled');
      }

      // Update next button state
      if (this.slider.isEnd) {
        this.domNodes.nextBtn.setAttribute('disabled', '');
      } else {
        this.domNodes.nextBtn.removeAttribute('disabled');
      }
    }

    onBlockSelect(evt) {
      const block = evt.target;
      const index = Number(block.dataset.index);
      if (this.slider) this.slider.slideToLoop(index);
      if (this.imageSlider) this.imageSlider.slideToLoop(index);
    }
  }

  customElements.define("m-ingredient-slider", MIngredientSlider);
}